import { ComponentTypes } from "../../../config/config";
import { IPageSettings } from "../../../interfaces/IPageSettings";
import { ILocationBuilder } from "../../../interfaces/ILocationBuilder";
import { IWorkingDirectoriesBuilder } from "../../../interfaces/IWorkingDirectoriesBuilder";
import { tryDecodeUriComponent } from "../../../../../utilities/EncodeDecode";

export class OneDriveWorkingDirectoriesBuilder implements IWorkingDirectoriesBuilder {
    constructor(private folderLocationBuilder: ILocationBuilder, private drives: any[], private oneDriveWebUrl: string, private sharePointListId: string) {
    }

    async build(): Promise<IPageSettings[]> {
        const initialLocation = this.folderLocationBuilder.getInitialLocation();
        const workingDirectories = this.drives.map((drive) => this.buidWorkingDirectories(drive));
        return [...[initialLocation], ...workingDirectories];
    }

    private buidWorkingDirectories(item: any): IPageSettings {
        return this.buildOneDriveFolderDirectory(item);
    }

    private buildOneDriveFolderDirectory(item: any): IPageSettings {
        const webUrl: string = item.listItem?.webUrl || item.webUrl;
        const result = {
            id: item.id,
            parentId: item?.parentReference?.driveId,
            type: ComponentTypes.OneDriveSubFolder,
            fileTitle: item.name,
            directory: tryDecodeUriComponent(webUrl?.replace(`${this.oneDriveWebUrl}/`, "")),
            DocumentLibrary: "",
            displayName: item.name,
            webUrl: this.oneDriveWebUrl,
            sharePointListId: this.sharePointListId,
            contentTypeId: item.listItem?.contentType?.id,
            serverRelativePath: webUrl && new URL(webUrl).pathname
        };

        return result;
    }
}
